import React from "react";
import { Facebook, Google } from "../common/svg";

export default class Login3rd extends React.Component {
	constructor(props) {
		super(props)
	}
	openFbLogin = () => {
		// if (this.props.login) {
		// 	window.gtag('event', "3RD_REGISTER", {
		// 		'event_category': utmSrc,
		// 		'event_label': utmExt
		// 	});

		// 	window.fbq('track', "3RD_REGISTER");
		// }
		
		window.miotoLogin.openPopup("facebook");
	
		return false;
	};

	openGgLogin = () => {
		// if (this.props.login) {
		// 	window.gtag('event', "3RD_REGISTER", {
		// 		'event_category': utmSrc,
		// 		'event_label': utmExt
		// 	});

		// 	window.fbq('track', "3RD_REGISTER");
		// }
		window.miotoLogin.openPopup("google");
		return false;
	};

	render() {
		return (
			<div className="wrap-btn db-btn-svg">
				<a className="btn btn--s btn-secondary" onClick={this.openFbLogin}>
					<div className="wrap-svg">
						<Facebook />
					</div>
					<span>Facebook</span>
				</a>
				<a className="btn btn--s btn-secondary" onClick={this.openGgLogin}>
					<div className="wrap-svg">
						<Google />
					</div>
					<span>Google</span>
				</a>
			</div>
		);
	}
}
